import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";
import { AppsService } from "src/app/shared/services/apps.service";
import { PermissionService } from "src/app/services/permission.service";
import { AddVehicleDeviceComponent } from "../../add-vehicle-device/add-vehicle-device.component";
import { GridToolbarItem } from "src/app/shared/components/data-grid/data-grid.module";

@Component({
  selector: "app-add-vechile",
  templateUrl: "./add-vechile.component.html",
  styleUrls: ["./add-vechile.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddVechileComponent implements OnInit {
  /** Add New Vehicle / Add New Device drawers (shared with the vehicle dashboard). */
  @ViewChild("vhclFrms") vhclFrms: AddVehicleDeviceComponent;

  vechile_lst: any;
  clnts: any;
  selectedclnt;
  selectedTnt;
  tnts: any;
  columnDefs: any;
  mstrDta: any;
  addvechleBtn = false;
  vchlDtaBtn = false;
  clnt_dtls: any;
  // Statistics properties
  totalVehicles: number = 0;
  totalDevices: number = 0;
  installedDevices: number = 0;
  filterPanelOpen: boolean = false;

  constructor(
    public apiServ: AppsService,
    private modal: NzModalService,
    private message: NzMessageService,
    public perms: PermissionService
  ) {
    this.clnt_dtls = JSON.parse(localStorage.getItem("wto_clients"));
    // Get user details for default client/tenant
    const userDtls = JSON.parse(localStorage.getItem("wto_w_user"));

    // Set default client and tenant from user details
    if (userDtls && userDtls.clnt_id) {
      this.selectedclnt = userDtls.clnt_id;
      // Find the client in clnt_dtls to get tenants
      const clientData = this.clnt_dtls.find(
        (c) => c.clnt_id === userDtls.clnt_id
      );
      if (clientData && clientData.tnts) {
        this.tnts = clientData.tnts;
        // Set default tenant from user details
        if (userDtls.tnt_id) {
          this.selectedTnt = userDtls.tnt_id;
        } else if (this.tnts.length > 0) {
          this.selectedTnt = this.tnts[0].tnt_id;
        }
      } else {
        // Fallback to first client if user's client not found
        this.selectedclnt = this.clnt_dtls[0].clnt_id;
        this.tnts = this.clnt_dtls[0].tnts;
        if (this.tnts.length > 0) {
          this.selectedTnt = this.tnts[0].tnt_id;
        }
      }
    } else {
      // Fallback to first client/tenant if no user details
      this.selectedclnt = this.clnt_dtls[0].clnt_id;
      this.tnts = this.clnt_dtls[0].tnts;
      if (this.tnts.length > 0) {
        this.selectedTnt = this.tnts[0].tnt_id;
      }
    }
  }

  ngOnInit(): void {
    this.getCLnt();

    // Auto-load vehicle list if client and tenant are selected
    if (this.selectedclnt && this.selectedTnt) {
      this.addvechleBtn = true;
      this.getVechiles();
    }
  }

  getVechiles() {
    this.apiServ
      .get(`drivers/add/Vehcile/${this.selectedclnt}/${this.selectedTnt}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            this.vechile_lst = res["data"];
            // Calculate statistics
            this.calculateStatistics();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    this.columnDefs = [
      { headerName: "S.No", field: "sno", width: 80 },

      { headerName: "Tenant Name", field: "tnt_nm", hide: false },
      { headerName: "Vehicle", field: "asrt_nm", hide: false },
      { headerName: "IMEI Number", field: "dev_imei_nu", hide: false },
      { headerName: "Vehicle Category", field: "asrt_ctgry_nm", hide: false },
      { headerName: "Vehicle Group", field: "asrt_grp_nm", hide: false },
    ];
  }

  calculateStatistics() {
    if (this.vechile_lst && this.vechile_lst.length > 0) {
      this.totalVehicles = this.vechile_lst.length;
      // Count vehicles with IMEI (installed devices)
      this.installedDevices = this.vechile_lst.filter(
        (v) => v.dev_imei_nu && v.dev_imei_nu !== "--" && v.dev_imei_nu !== ""
      ).length;
      // Get total devices from master data if available
      if (this.mstrDta && this.mstrDta.Imei) {
        this.totalDevices = this.mstrDta.Imei.length;
      } else {
        // Fallback: total devices = installed + uninstalled (estimated)
        this.totalDevices =
          this.installedDevices + (this.totalVehicles - this.installedDevices);
      }
    } else {
      this.totalVehicles = 0;
      this.installedDevices = 0;
      this.totalDevices = 0;
    }
  }

  /** Master data reloaded inside the drawers - refresh the device counter. */
  onMstrDta(mstrDta) {
    this.mstrDta = mstrDta;
    this.calculateStatistics();
  }

  /** Client/tenant changed from inside a drawer - keep the grid in sync. */
  onCtxChange(ctx) {
    this.selectedclnt = ctx.clnt_id;
    this.selectedTnt = ctx.tnt_id;
    this.vchlDtaBtn = true;
    if (this.selectedclnt && this.selectedTnt && this.addvechleBtn) {
      this.getVechiles();
    }
  }

  /** A vehicle or device was saved - reload the grid. */
  onSaved() {
    this.getVechiles();
  }

  toggleFilterPanel() {
    this.filterPanelOpen = !this.filterPanelOpen;
  }

  slct_clnt(value) {
    this.selectedclnt = value;
    this.selectedTnt = null;
    this.vchlDtaBtn = false;
    this.addvechleBtn = false;
    this.vechile_lst = [];
    this.totalVehicles = 0;
    this.totalDevices = 0;
    this.installedDevices = 0;
  }
  getCLnt() {
    this.apiServ.get(`drivers/add/clntdtls`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.clnts = res["data"];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  /** Grid toolbar buttons (the migrated replacement for onToolbarPreparing). */
  gridToolbar: GridToolbarItem[] = [
    {
      text: "Add New Device",
      icon: "plus",
      onClick: () => this.addDvce("new", null),
    },
    {
      text: "Add New Vehicle",
      icon: "plus",
      onClick: () => this.openSideBar("new", null),
    },
  ];

  addDvce(param, val) {
    if (this.addvechleBtn) {
      this.vhclFrms.openDevice();
    } else {
      this.createMessage("error", "Please Select Client and Tenant");
    }
  }
  openSideBar(edt, val) {
    if (this.addvechleBtn) {
      this.vhclFrms.openVehicle(edt === "Edit" ? "Edit" : "new", val);
    } else {
      this.createMessage("error", "Please Select Client and Tenant");
    }
  }
  slct_tnt(val) {
    this.selectedTnt = val;
    this.vchlDtaBtn = true;
    if (this.addvechleBtn) {
      this.getVechiles();
    }
  }
  getAsrtDtls() {
    this.getVechiles();
    this.addvechleBtn = true;
  }

  showDeleteConfirm(data): void {
    this.modal.confirm({
      nzTitle: "Are you sure delete this vehicle?",
      nzContent: `<b style="color: red;">${data.asrt_nm}</b>`,
      nzOkText: "Yes",
      nzOkType: "primary",
      nzOkDanger: true,
      nzOnOk: () => this.delAsrt(data.asrt_id),
      nzCancelText: "No",
      nzOnCancel: () => console.log("Cancel"),
    });
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }

  delAsrt(asrt) {
    let postData = {
      asrt_id: asrt,
    };
    this.apiServ.post(postData, `drivers/del/vechile`).subscribe((res) => {
      if (res["status"] == 200) {
        this.createMessage("success", "Vehicle successfully Deleted");
      }
      this.getVechiles();
    });
  }
}
